import Autocomplete from "react-google-autocomplete";
import Loading from "./shared/Loading";
import { BiCurrentLocation } from "react-icons/bi";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { logEvent } from "../utils/analytics";

const GOOGLE_AUTOCOMPLETE_API_KEY = 'AIzaSyAfH6RriIeqgnV9VAt_FXvA0P - aKLwM_s0';
const autoCompleteOptions = {
    types: ["address"],
    componentRestrictions: { country: "ng" },
};

const Search = ({ queryLocation, loading }) => {

    const navigate = useNavigate();
    const [street, setStreet] = useState(queryLocation?.street || '');

    const onSelect = (place) => {

        const street = place.formatted_address;
        logEvent('Search', 'Select search location', street)

        const newLocation = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            street,
        }

        getLocationData(newLocation);
    }

    const getLocationData = ({ lat, lng, street }) => {
        navigate({
            pathname: "/results",
            search: `?position=${lat},${lng}${street ? `&street=${street}` : ''}`,
        });
    };

    const onUseCurrentLocation = () => {

        logEvent('Search', 'Select location', "Use current location")

        if (navigator.geolocation) {
            // get the current users location
            navigator.geolocation.getCurrentPosition(
                (position) => {

                    const { latitude, longitude } = position.coords;
                    setStreet('')
                    getLocationData({ lat: latitude, lng: longitude });
                },
                (error) => {
                    console.error('Error getting user location:', error);
                }
            );
        }

        else {
            alert("Geolocation is not enabled");
            return;
        }
    }

    return (

        <div className="flex flex-col gap-1.5 items-center justify-center">
            <label className="h-14 md:max-w-[400px] w-full max-w-[360px]">
                <div className="flex bg-white border border-neutral-200 focus-within:border-neutral-300 shadow-lg items-stretch h-full px-3.5 rounded-full text-gray-900 ">
                    <div
                        className="flex items-center justify-center text-gray-500"
                        data-icon="MagnifyingGlass"
                        data-size="24px"
                        data-weight="regular"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                            <path
                                d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"
                            ></path>
                        </svg>
                    </div>
                    <Autocomplete
                        options={autoCompleteOptions}
                        apiKey={GOOGLE_AUTOCOMPLETE_API_KEY}
                        onPlaceSelected={onSelect}
                        className="grow bg-transparent overflow-hidden focus:outline-0 focus:ring-0 focus:border-none border-none h-full placeholder:text-gray-400 text-base font-normal leading-normal"
                        type="text"
                        value={street}
                        onChange={(e) => setStreet(e.target.value)}
                        placeholder="e.g 20 admiralty way, Lekki"
                    />

                    {loading && <div className="flex items-center justify-center">
                        <Loading />
                    </div>}

                    {(!loading && street) && <button onClick={() => setStreet('')} className="flex items-center justify-center text-gray-400">
                        <MdClose />
                    </button>}
                </div>
            </label>

            <button className="md:text-base text-sm flex gap-1.5 items-center px-2 text-blue-600 hover:text-blue-700 bg-white/10 rounded backdrop-blur" onClick={onUseCurrentLocation}>
                <BiCurrentLocation />
                <p>or use your current location</p>
            </button>
        </div>
    )
}

export default Search;
